module.exports = new __parcel__URL__("AdobeExperienceCloud.bfdb429e.svg").toString();